import { render, staticRenderFns } from "./Tebus.vue?vue&type=template&id=52f35bab&"
import script from "./Tebus.vue?vue&type=script&lang=js&"
export * from "./Tebus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports